import React from "react";
import pwa from "../../../../assets/images/pwa.svg";
import pwr from "../../../../assets/images/pwr.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faDiscord, faInstagram } from '@fortawesome/free-brands-svg-icons';
import getIconForSocialNetwork from '../../../../helpers/getIconForSocialNetwork';

const Footer = ({ data }) => {

  // Get the current year for the copyright text
  const date = new Date();
  const year = date.getFullYear();
  const { footerImages } = data;

  return (
    <footer
      style={{
        // Set background image depending on whether footerImages data is available
        backgroundImage: Object.keys(footerImages).length === 0
          ? `url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOTI3LjAyOSIgaGVpZ2h0PSI4NjEuNTU0IiB2aWV3Qm94PSIwIDAgMTkyNy4wMjkgODYxLjU1NCI+CiAgPHBhdGggaWQ9IkJvdHRvbV8yIiBkYXRhLW5hbWU9IkJvdHRvbSAyIiBkPSJNODI1Mi42MTEsMjE4NC45MzNjLTEuMTktNzQ3LjY2MywwLDYzOC4yMzcsMCw2MzguMjM3bC0xOTI3LjAyOCwxLjk0MSwzLjQ4Ny0yNzIuMjE5UzgyNTMuOCwyOTMyLjYsODI1Mi42MTEsMjE4NC45MzNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjMyNS41ODMgLTE5NjMuNTU3KSIgZmlsbD0iIzZGNkY2RiIvPgo8L3N2Zz4K"), url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOTI3LjQ5MyIgaGVpZ2h0PSI0MjcuMDY3IiB2aWV3Qm94PSIwIDAgMTkyNy40OTMgNDI3LjA2NyI+CiAgPHBhdGggaWQ9IkJvdHRvbV8xIiBkYXRhLW5hbWU9IkJvdHRvbSAxIiBkPSJNNjMyOCwzNjg3LjY1NWwyLTM4OC4wMTVzMTUyNi44LTIzLjUxMSwxOTIwLjk5MiwyMjcuNjc1YzcuMzE4LDMyMy4zMiwzLjUxMSwxNTUuMDI0LDMuNTExLDE1NS4wMjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjMyOCAtMzI5OS4wNTUpIiBmaWxsPSIjRUFFQUVBIi8+Cjwvc3ZnPgo=")`
          : `url("data:image/svg+xml;base64,${footerImages.svg2}"),url("data:image/svg+xml;base64,${footerImages.svg1}")`
      }}
    >
      {/* Desktop Footer Section */}
      <div className="desktop-footer">
        <div className="footer__social-icons">
          {/* Social Icons based on footer data */}
          {data.ct_social_link_1 ? (
            // Render dynamic social link if available
            <a href={`${data.ct_social_link_1}`} target="_blank" rel="noreferrer">
              {getIconForSocialNetwork(data.ct_social_link_1, data.web_main_color, 'preview')}
            </a>
          ) : (
            // Default Instagram link if no dynamic link provided
            <a href="https://www.instagram.com/FundRaisinApp" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} style={{ height: '2.7rem', color: "#6f6f6f" }} />
            </a>
          )}

          {data.ct_social_link_2 ? (
            // Render dynamic social link if available
            <a href={`${data.ct_social_link_2}`} target="_blank" rel="noreferrer">
              {getIconForSocialNetwork(data.ct_social_link_2, data.web_main_color, 'preview')}
            </a>
          ) : (
            // Default Twitter link if no dynamic link provided
            <a href="https://twitter.com/FundRaisinApp" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faXTwitter} style={{ height: '2.7rem', color: "#6f6f6f" }} />
            </a>
          )}

          {data.ct_social_link_3 ? (
            // Render dynamic social link if available
            <a href={`${data.ct_social_link_3}`} target="_blank" rel="noreferrer">
              {getIconForSocialNetwork(data.ct_social_link_3, data.web_main_color, 'preview')}
            </a>
          ) : (
            // Default Discord link if no dynamic link provided
            <a href="https://discord.gg/R9g6Jjy7TW" target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faDiscord} style={{ height: '2.7rem', color: "#6f6f6f" }} />
            </a>
          )}
        </div>

        {/* Footer copyright text */}
        <div className="footer__copyright">
          <span className="footer__copyright-text">
            © {year} RED.DEV INC. All Rights Reserved.
          </span>

          {/* Logos for Avalanche and RED.DEV */}
          <div className="footer__pwb">
            <div className="footer__pwb-inner">
              <div className="footer__pwb-avalanche">
                <img className="front" src={pwa} alt="pwa" />
              </div>
              <div className="footer__pwb-reddev">
                <img className="back" src={pwr} alt="pwr" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Footer Section */}
      <div className="mobile-footer">
        <div className="footer-group1">
          {/* Social icons for mobile layout */}
          <div className="mobile-footer__social-icons">
            <a href={`${data.ct_social_link_1}`} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faXTwitter} style={{ height: '2.7rem', color: data.web_main_color || "#6f6f6f" }} />
            </a>
            <a href={`${data.ct_social_link_2}`} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faDiscord} style={{ height: '2.7rem', color: data.web_main_color || "#6f6f6f" }} />
            </a>
            <a href={`${data.ct_social_link_3}`} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} style={{ height: '2.7rem', color: data.web_main_color || "#6f6f6f" }} />
            </a>
          </div>

          {/* Logos for Avalanche and RED.DEV in mobile layout */}
          <div className="footer__pwb">
            <div className="footer__pwb-inner">
              <div className="footer__pwb-avalanche">
                <img className="front" src={pwa} alt="pwa" />
              </div>
              <div className="footer__pwb-reddev">
                <img className="back" src={pwr} alt="pwr" />
              </div>
            </div>
          </div>
        </div>

        {/* Footer copyright text for mobile layout */}
        <span className="footer__copyright-text">
          © {year} RED.DEV INC. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
